import { useQuery } from '@apollo/client';
import { Async } from '@client/new/helpers/types';
import { useAsyncQueryRaw } from '@client/new/helpers/gql';
import {
  GetCommunityUserEmailDocument,
  GetCommunityUserEmailQuery,
} from './communityUserEmail.generated';

export type CommunityUserEmail = {
  email: string | null;
  allowEmails: boolean | null;
};

const mapUserEmail = (
  data?: GetCommunityUserEmailQuery,
): CommunityUserEmail => ({
  email: data?.findUserById?.email || data?.findUserById?.verifiedEmail || null,
  allowEmails: data?.findUserById?.allowEmails ?? null,
});

export const useCommunityUserEmailModel = (
  userId?: number,
  enabled = true,
): Async<CommunityUserEmail> => {
  const shouldSkip = !userId || !enabled;
  const query = useQuery(GetCommunityUserEmailDocument, {
    variables: { id: userId ?? 0 },
    skip: shouldSkip,
    fetchPolicy: 'network-only',
  });

  const { data } = useAsyncQueryRaw({
    query,
    mapper: mapUserEmail,
  });

  return data;
};
